import React, { useEffect, useRef, useState, useMemo } from 'react';
import { documentCfValue } from '../../utils/codiceFiscale';
import unsplash from '../../api/unsplash';
import {
    DataGridPro,
    itIT,
    GridToolbarContainer,
    GridToolbarQuickFilter,
    GridActionsCellItem,
} from '@mui/x-data-grid-pro';
import {
    IconButton,
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    Box,
    Autocomplete,
    FormControlLabel,
    Checkbox,
    Zoom,
    LinearProgress,
    Tooltip,
    Typography,
    CircularProgress,
    Alert,
    Chip,
    MenuItem,
} from '@mui/material';
import '../../style/style.css';
import {
    Edit,
    Delete,
    Add,
    Download,
    Upload,
    Close,
    Check,
    Visibility,
} from '@mui/icons-material';
import GlobalSnackbar from '../Snackbar';
import moment from 'moment';
import jsPDF from 'jspdf';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterMoment as DateAdapter } from '@mui/x-date-pickers/AdapterMoment';
import Dropzone from 'react-dropzone';
import { useDropzone } from 'react-dropzone';
import { CustomFooterPersonalized } from '../../utils/CustomFooterPersonalized';
var QRCode = require('qrcode');

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const elearningCache = new Map();
const attestatiConfigCache = new Map();
const clientCache = new Map();
const courseRowsCache = new Map();

const normalizeCourseCode = (value) =>
    String(value || '').trim().toUpperCase();

const ext = {
    doc: 'application/msword',
    dot: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    dotx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    docm: 'application/vnd.ms-word.document.macroEnabled.12',
    dotm: 'application/vnd.ms-word.template.macroEnabled.12',
    xls: 'application/vnd.ms-excel',
    xlt: 'application/vnd.ms-excel',
    xla: 'application/vnd.ms-excel',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xltx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
    xlsm: 'application/vnd.ms-excel.sheet.macroEnabled.12',
    xltm: 'application/vnd.ms-excel.template.macroEnabled.12',
    xlam: 'application/vnd.ms-excel.addin.macroEnabled.12',
    xlsb: 'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
    ppt: 'application/vnd.ms-powerpoint',
    pot: 'application/vnd.ms-powerpoint',
    pps: 'application/vnd.ms-powerpoint',
    ppa: 'application/vnd.ms-powerpoint',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    potx: 'application/vnd.openxmlformats-officedocument.presentationml.template',
    ppsx: 'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
    ppam: 'application/vnd.ms-powerpoint.addin.macroEnabled.12',
    pptm: 'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
    potm: 'application/vnd.ms-powerpoint.template.macroEnabled.12',
    ppsm: 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12',
    mdb: 'application/vnd.ms-access',
    pdf: 'application/pdf',
};

function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
            >
                <GridToolbarQuickFilter placeholder="Cerca..." />
            </Grid>
        </GridToolbarContainer>
    );
}

const CorsiLavoratore = (props) => {
    const { idAzienda, idLavoratore, lavoratore } = props;
    const [corsiLavoratore, setCorsiLavoratore] = useState([]);
    const [corsiElearning, setCorsiElearning] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingElearning, setLoadingElearning] = useState(false);
    const [elearningError, setElearningError] = useState(false);
    const [corsi, setCorsi] = useState([]);
    const [openSnack, setOpenSnack] = useState(false);
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });
    const rows = useMemo(() => {
        const rowsByCode = new Map();
        const deferredOfflineByCode = new Map();

        corsiLavoratore.forEach((corso) => {
            const normalizedCode = normalizeCourseCode(corso.Ruolo);
            const normalizedRow = {
                ...corso,
                rowId: `corso-${corso.Ruolo}`,
                Tipologia: 'Corso',
                CodiceVisualizzato: corso.Ruolo,
                DescrizioneVisualizzata: corso.Descrizione,
                DataCorsoVisualizzata: corso.BaseData,
                ScadenzaCorsoVisualizzata: corso.BaseScadenza,
                DataAggVisualizzata: corso.AggiornamentoData,
                ScadenzaAggVisualizzata: corso.AggiornamentoScadenza,
                DataInizioVisualizzata: null,
                DataFineVisualizzata: null,
                CompletamentoVisualizzato: null,
                isElearning: false,
                sortGroup: 0,
            };

            if (normalizedCode.includes('/')) {
                deferredOfflineByCode.set(normalizedCode, normalizedRow);
                return;
            }

            rowsByCode.set(normalizedCode, normalizedRow);
        });

        corsiElearning.forEach((corso) => {
            const codice = corso.Codice || `elearning-${corso.CorsoID}`;
            const normalizedCode = normalizeCourseCode(codice);
            const existingRow =
                rowsByCode.get(normalizedCode) ||
                deferredOfflineByCode.get(normalizedCode);

            if (existingRow) {
                rowsByCode.set(normalizedCode, {
                    ...existingRow,
                    Tipologia: 'E-learning',
                    DataInizioVisualizzata: corso.DataInizio,
                    DataFineVisualizzata: corso.DataFine,
                    CompletamentoVisualizzato: corso.perc_course,
                    isElearning: true,
                    sortGroup: 1,
                });
                deferredOfflineByCode.delete(normalizedCode);
                return;
            }

            rowsByCode.set(normalizedCode, {
                ...corso,
                rowId: `elearning-${corso.CorsoID}`,
                Tipologia: 'E-learning',
                CodiceVisualizzato: corso.Codice || '-',
                DescrizioneVisualizzata: corso.Descrizione,
                DataCorsoVisualizzata: null,
                ScadenzaCorsoVisualizzata: null,
                DataAggVisualizzata: null,
                ScadenzaAggVisualizzata: null,
                DataInizioVisualizzata: corso.DataInizio,
                DataFineVisualizzata: corso.DataFine,
                CompletamentoVisualizzato: corso.perc_course,
                isElearning: true,
                sortGroup: 1,
            });
        });

        if (!loadingElearning) {
            deferredOfflineByCode.forEach((row, codice) => {
                rowsByCode.set(codice, {
                    ...row,
                    Tipologia: 'E-learning',
                    isElearning: true,
                    sortGroup: 2,
                });
            });
        }

        return Array.from(rowsByCode.values()).sort((a, b) => {
            const aPriority = a.sortGroup ?? 0;
            const bPriority = b.sortGroup ?? 0;

            if (aPriority !== bPriority) {
                return aPriority - bPriority;
            }

            return (a.CodiceVisualizzato || '').localeCompare(
                b.CodiceVisualizzato || '',
                'it',
                { sensitivity: 'base' }
            );
        });
    }, [corsiLavoratore, corsiElearning, loadingElearning]);

    const columns = [
        {
            filterable: false,
            field: 'Actions',
            type: 'actions',
            headerName: 'Azioni',
            headerAlign: 'center',
            hide: false,
            width: '150',
            align: 'center',
            sortable: false,
            getActions: (params) =>
                params.row.isElearning
                    ? [
                          <ElearningCertificateAction
                              row={params.row}
                              lavoratore={lavoratore}
                              idAzienda={idAzienda}
                              setSnack={setSnack}
                              setOpenSnack={setOpenSnack}
                          />,
                      ]
                    : [
                    <CorsiDialog
                        id="corsiEdit"
                        title="Dettaglio Corso"
                        idLavoratore={props.idLavoratore}
                        tipo={params.row.Ruolo}
                        snack={snack}
                        openSnack={openSnack}
                        handleCloseSnack={handleCloseSnack}
                        setSnack={setSnack}
                        setOpenSnack={setOpenSnack}
                    />,
                    <DeleteDialog
                        corsoToDelete={params.row}
                        myFunction={() => refreshData()}
                    />,
                ],
        },
        {
            field: 'Tipologia',
            headerName: 'Tipologia',
            flex: 0.8,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'CodiceVisualizzato',
            headerName: 'Codice',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'DescrizioneVisualizzata',
            headerName: 'Descrizione',
            flex: 1.4,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'DataCorsoVisualizzata',
            headerName: 'Data Corso',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.DataCorsoVisualizzata
                            ? moment(params.row.DataCorsoVisualizzata).format(
                                  'DD/MM/YYYY'
                              )
                            : ''}
                    </div>
                );
            },
        },
        {
            field: 'ScadenzaCorsoVisualizzata',
            headerName: 'Scadenza Corso',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.ScadenzaCorsoVisualizzata
                            ? moment(params.row.ScadenzaCorsoVisualizzata).format(
                                  'DD/MM/YYYY'
                              )
                            : ''}
                    </div>
                );
            },
        },
        {
            field: 'DataAggVisualizzata',
            headerName: 'Data Agg.',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.DataAggVisualizzata
                            ? moment(params.row.DataAggVisualizzata).format(
                                  'DD/MM/YYYY'
                              )
                            : ''}
                    </div>
                );
            },
        },
        {
            field: 'ScadenzaAggVisualizzata',
            headerName: 'Scadenza Agg.',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.ScadenzaAggVisualizzata
                            ? moment(params.row.ScadenzaAggVisualizzata).format(
                                  'DD/MM/YYYY'
                              )
                            : ''}
                    </div>
                );
            },
        },
        {
            field: 'DataInizioVisualizzata',
            headerName: 'Data Inizio',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) =>
                params.row.DataInizioVisualizzata
                    ? moment(params.row.DataInizioVisualizzata).format(
                          'DD/MM/YYYY'
                      )
                    : '',
        },
        {
            field: 'DataFineVisualizzata',
            headerName: 'Data Fine',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) =>
                params.row.DataFineVisualizzata
                    ? moment(params.row.DataFineVisualizzata).format(
                          'DD/MM/YYYY'
                      )
                    : '',
        },
        {
            field: 'CompletamentoVisualizzato',
            headerName: 'Completamento',
            flex: 0.9,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) =>
                params.row.CompletamentoVisualizzato !== null &&
                params.row.CompletamentoVisualizzato !== undefined
                    ? `${params.row.CompletamentoVisualizzato}%`
                    : '-',
        },
    ];

    useEffect(() => {
        let isMounted = true;

        async function fetchData() {
            try {
                const [responsecorsiLavoratore, responsecorsi] =
                    await Promise.all([
                        unsplash.get('corsiLavoratore', {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem(
                                    'jwt'
                                )}`,
                            },
                            params: { lavoratore: idLavoratore },
                        }),
                        unsplash.get('anagraficaCorsi', {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem(
                                    'jwt'
                                )}`,
                            },
                            params: { ID: idAzienda },
                        }),
                    ]);

                if (!isMounted) {
                    return;
                }

                setCorsiLavoratore(responsecorsiLavoratore.data.data);
                setCorsi(responsecorsi.data.data);
                setLoading(false);

                setElearningError(false);
                const cachedElearning = elearningCache.get(idLavoratore);
                if (cachedElearning) {
                    setCorsiElearning(cachedElearning);
                    setLoadingElearning(false);
                    return;
                }

                setLoadingElearning(true);

                try {
                    const responseElearning = await unsplash.get(
                        'corsiLavoratore/elearning',
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem(
                                    'jwt'
                                )}`,
                            },
                            params: { lavoratore: idLavoratore },
                        }
                    );

                    if (!isMounted) {
                        return;
                    }

                    elearningCache.set(
                        idLavoratore,
                        responseElearning.data.data || []
                    );
                    setCorsiElearning(responseElearning.data.data);
                } catch (error) {
                    console.error(error);

                    if (isMounted) {
                        setElearningError(true);
                        setCorsiElearning([]);
                    }
                } finally {
                    if (isMounted) {
                        setLoadingElearning(false);
                    }
                }
            } catch (error) {
                console.error(error);
                if (isMounted) {
                    setCorsiElearning([]);
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        }

        fetchData();

        return () => {
            isMounted = false;
        };
    }, [idAzienda, idLavoratore]);

    const handleSaveData = async (corso, operazione) => {
        try {
            //inserisco il nuovo
            try {
                await unsplash.post(
                    'corsiLavoratore',
                    { lavoratore: props.idLavoratore, corso: corso.Codice },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                    }
                );

                let responsecorsiLavoratore = await unsplash.get(
                    'corsiLavoratore',
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                        params: { lavoratore: props.idLavoratore },
                    } //props.idAzienda}}
                );

                setCorsiLavoratore(responsecorsiLavoratore.data.data);
                setSnack({
                    severity: 'success',
                    messaggio: 'Corso inserito con successo',
                });
                setOpenSnack(true);
            } catch {
                setSnack({
                    severity: 'error',
                    messaggio: "Errore durante l'inserimento",
                });
                setOpenSnack(true);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const refreshData = async () => {
        let responsecorsiLavoratore = await unsplash.get(
            'corsiLavoratore',
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                params: { lavoratore: props.idLavoratore },
            } //props.idAzienda}}
        );

        setCorsiLavoratore(responsecorsiLavoratore.data.data);
    };
    return (
        <>
            {elearningError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                    Impossibile caricare i corsi e-learning. Riapri la scheda per riprovare.
                </Alert>
            )}
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />
            <Grid
                container
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
                spacing={2}
            >
                <Button
                    startIcon={<Upload />}
                    onClick={() => document.getElementById('storicoFormazioneImport').click()}
                    sx={{ color: 'white', mr: 1 }}
                    variant="contained"
                    className="ButtonMiller"
                >
                    Carica storico formazione
                </Button>
                <Button
                    startIcon={<Add />}
                    onClick={() => document.getElementById('addCorso').click()}
                    id={props.id}
                    sx={{ color: 'white' }}
                    variant="contained"
                    className="ButtonMiller"
                >
                    Aggiungi
                </Button>
            </Grid>

            <StoricoFormazioneDialog
                id="storicoFormazione"
                idLavoratore={props.idLavoratore}
                idAzienda={idAzienda}
                corsi={corsi}
                onImported={refreshData}
            />

            <FormDialog
                id="addCorso"
                idLavoratore={props.idLavoratore}
                operazione="Inserimento"
                corsiLavoratore={corsiLavoratore}
                corsi={corsi.filter(
                    (corso) =>
                        !corsiLavoratore?.some((c) => c.Ruolo === corso.Codice)
                )}
                saveFunction={handleSaveData}
            />

            <div style={{ height: '55vh', width: '100%' }}>
                {loadingElearning && !loading && (
                    <Box
                        sx={{ mb: 1, color: 'text.secondary' }}
                    >
                        <Box
                            sx={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: 1,
                            }}
                        >
                            <CircularProgress size={16} />
                            <Typography variant="body2">
                                Caricamento corsi e-learning...
                            </Typography>
                        </Box>
                    </Box>
                )}
                <DataGridPro
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooterPersonalized,
                    }}
                    componentsProps={{
                        cell: {
                            onClick: (event) => {
                                event.stopPropagation();
                            },
                        },
                        row: {
                            onClick: (event) => {
                                event.stopPropagation();
                            },
                        },
                    }}
                    slots={{
                        loadingOverlay: LinearProgress,
                    }}
                    loading={loading}
                    initialState={{ pinnedColumns: { left: ['Actions'] } }}
                    localeText={
                        itIT.components.MuiDataGrid.defaultProps.localeText
                    }
                    rows={rows}
                    getRowId={(row) => row.rowId}
                    columns={columns}
                    disableSelectionOnClick
                />
            </div>
        </>
    );
};

const ElearningCertificateAction = ({
    row,
    lavoratore,
    idAzienda,
    setSnack,
    setOpenSnack,
}) => {
    const [loading, setLoading] = useState(false);

    const openPdf = (doc, filename) => {
        const blob = doc.output('blob');
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
    };

    const cap = (value) =>
        (value || '')
            .toString()
            .split(' ')
            .filter(Boolean)
            .map(
                (part) =>
                    part.charAt(0).toUpperCase() +
                    part.substring(1).toLowerCase()
            )
            .join(' ');

    const sanitizeFilename = (value) =>
        (value || 'attestato')
            .toLowerCase()
            .replace(/[^a-z0-9]+/gi, '-')
            .replace(/^-+|-+$/g, '')
            .replace(/--+/g, '-');

    const getClient = async () => {
        if (clientCache.has(idAzienda)) {
            return clientCache.get(idAzienda);
        }

        const response = await unsplash.get(`clienti/${idAzienda}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
        });
        const client = response?.data?.data || null;
        clientCache.set(idAzienda, client);
        return client;
    };

    const getAttestatoConfig = async () => {
        const cacheKey = row.CodiceVisualizzato;
        if (attestatiConfigCache.has(cacheKey)) {
            return attestatiConfigCache.get(cacheKey);
        }

        const response = await unsplash.get('corsiAttestati', {
            params: { idCorso: row.CodiceVisualizzato },
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
        });

        const config =
            response?.data?.data?.find((item) => item.Aggiornamento !== 1) ||
            response?.data?.data?.[0] ||
            null;
        attestatiConfigCache.set(cacheKey, config);
        return config;
    };

    const getCourseRows = async () => {
        if (!row.CorsoID) {
            return [];
        }
        if (courseRowsCache.has(row.CorsoID)) {
            return courseRowsCache.get(row.CorsoID);
        }

        const response = await unsplash.get('corsi', {
            params: { idCorso: row.CorsoID },
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
        });
        const courseRows = response?.data?.data || [];
        courseRowsCache.set(row.CorsoID, courseRows);
        return courseRows;
    };

    const getLogoData = async (client) => {
        const rawLogo = client?.Logo?.trim();
        if (!rawLogo) {
            return null;
        }
        if (rawLogo.startsWith('data:image/')) {
            return {
                dataUrl: rawLogo,
                format:
                    rawLogo.includes('image/jpeg') ||
                    rawLogo.includes('image/jpg')
                        ? 'JPEG'
                        : 'PNG',
            };
        }

        const maybeBase64 =
            rawLogo.startsWith('/9j') || rawLogo.startsWith('iVBOR');
        if (maybeBase64) {
            const mime = rawLogo.startsWith('/9j') ? 'image/jpeg' : 'image/png';
            return {
                dataUrl: `data:${mime};base64,${rawLogo}`,
                format: mime === 'image/jpeg' ? 'JPEG' : 'PNG',
            };
        }

        return null;
    };

    const handleDownload = async (event) => {
        event.stopPropagation();
        if (loading) {
            return;
        }

        try {
            setLoading(true);

            const [attestatoConfig, client, courseRows] = await Promise.all([
                getAttestatoConfig(),
                getClient(),
                getCourseRows(),
            ]);

            const doc = new jsPDF('portrait', 'pt', 'A4');
            const width = doc.internal.pageSize.getWidth();
            const height = doc.internal.pageSize.getHeight();
            const totalHours = (courseRows || []).reduce(
                (sum, current) => sum + Number(current?.Durata || 0),
                0
            );
            const startText = row.DataInizioVisualizzata
                ? moment(row.DataInizioVisualizzata).format('DD/MM/YYYY')
                : 'DATA INIZIO NON INSERITA';
            const endText = row.DataFineVisualizzata
                ? moment(row.DataFineVisualizzata).format('DD/MM/YYYY')
                : 'DATA FINE NON INSERITA';

            const background = new Image();
            background.src = require('../../assets/images/backCertificate_astm.png');
            await new Promise((resolve) => {
                background.onload = resolve;
                background.onerror = resolve;
            });
            doc.addImage(background, 'PNG', 0, 0, width, height);

            const logoData = await getLogoData(client);
            if (logoData?.dataUrl) {
                try {
                    doc.addImage(
                        logoData.dataUrl,
                        logoData.format,
                        30,
                        30,
                        150,
                        80
                    );
                } catch (error) {
                    console.error('Errore addImage logo attestato', error);
                }
            }

            const qrCode = await QRCode.toDataURL(
                `${lavoratore?.ID || ''}-${row.CodiceVisualizzato}-${endText}`,
                {
                    errorCorrectionLevel: 'H',
                    type: 'image/jpeg',
                    quality: 0.3,
                    margin: 1,
                    color: {
                        dark: '#2264ae',
                        light: '#FFFFFF',
                    },
                }
            );
            doc.addImage(qrCode, 'JPEG', 33, 107, 50, 50);

            doc.setFontSize(24);
            doc.setTextColor(34, 100, 174);
            doc.setFont(undefined, 'bold');
            doc.text('ATTESTATO DI PARTECIPAZIONE', 33, 195);

            doc.setFontSize(12);
            doc.setTextColor(0, 0, 0);
            doc.setFont(undefined, 'normal');
            doc.text(
                doc.splitTextToSize(
                    attestatoConfig?.Attestato1 ||
                        'Con la presente si attesta la partecipazione e il completamento del percorso formativo sotto indicato.',
                    doc.internal.pageSize.getWidth() - 150
                ),
                33,
                215
            );

            doc.setFont(undefined, 'bold');
            doc.text('Si attesta che:', 33, 265);

            doc.setFontSize(16);
            doc.setTextColor(34, 100, 174);
            doc.text(
                `${cap(lavoratore?.Nome)} ${cap(lavoratore?.Cognome)}`.trim(),
                33,
                290
            );

            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);
            doc.setFont(undefined, 'bold');
            doc.text('CF: ', 33, 310);
            doc.setFont(undefined, 'normal');
            doc.text(documentCfValue(lavoratore), 52, 310);
            doc.setFont(undefined, 'bold');
            doc.text('LUOGO DI NASCITA: ', 33, 325);
            doc.setFont(undefined, 'normal');
            doc.text(lavoratore?.LuogoDiNascita || '', 136, 325);
            doc.setFont(undefined, 'bold');
            doc.text('DATA DI NASCITA: ', 33, 340);
            doc.setFont(undefined, 'normal');
            doc.text(
                lavoratore?.DataDiNascita
                    ? moment(lavoratore.DataDiNascita).format('DD/MM/YYYY')
                    : '',
                127,
                340
            );

            doc.setFont(undefined, 'bold');
            doc.text('HA PARTECIPATO E SUPERATO LE PROVE FINALI DEL CORSO:', 33, 365);
            doc.setFontSize(14);
            doc.setTextColor(34, 100, 174);
            doc.text(
                doc.splitTextToSize(
                    (
                        attestatoConfig?.Attestato2 ||
                        row.DescrizioneVisualizzata ||
                        ''
                    ).toUpperCase(),
                    doc.internal.pageSize.getWidth() - 50
                ),
                33,
                385
            );

            doc.setFontSize(10);
            doc.setTextColor(0, 0, 0);
            if (totalHours) {
                doc.setFont(undefined, 'bold');
                doc.text('MONTE ORE FREQUENTATO: ', 33, 425);
                doc.setFont(undefined, 'normal');
                doc.text(`${totalHours} ORE`, 178, 425);
            }
            if (client?.CodiceATECO) {
                doc.setFont(undefined, 'bold');
                doc.text('SETTORE DI RIFERIMENTO: ', 33, 440);
                doc.setFont(undefined, 'normal');
                doc.text(client.CodiceATECO, 170, 440);
            }
            doc.setFont(undefined, 'bold');
            doc.text('SEDE/MODALITÀ DI EROGAZIONE DEL CORSO:', 33, 485);
            doc.setFont(undefined, 'normal');
            doc.text('E-LEARNING', 265, 485);

            doc.setFont(undefined, 'bold');
            doc.text('PERIODO DI SVOLGIMENTO DEL CORSO: ', 33, 500);
            doc.setFont(undefined, 'normal');
            doc.text(`${startText} - ${endText}`, 237, 500);

            doc.setTextColor(141, 196, 235);
            doc.text(
                doc.splitTextToSize(
                    attestatoConfig?.Attestato3 || '',
                    doc.internal.pageSize.getWidth() - 200
                ),
                200,
                565
            );

            openPdf(
                doc,
                `attestato_${sanitizeFilename(row.DescrizioneVisualizzata)}_${sanitizeFilename(
                    `${cap(lavoratore?.Cognome)}_${cap(lavoratore?.Nome)}`
                )}.pdf`
            );
        } catch (error) {
            console.error('Errore generazione attestato e-learning', error);
            setSnack({
                severity: 'error',
                messaggio: "Errore durante la generazione dell'attestato",
            });
            setOpenSnack(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <GridActionsCellItem
            icon={<Download style={{ color: '#2265B1' }} />}
            label="Download attestato"
            onClick={handleDownload}
            disabled={loading}
        />
    );
};

const FormDialog = (props) => {
    const [open, setOpen] = useState(false);
    const [corsoSel, setCorsoSel] = useState('');

    const handleClickOpen = () => {
        setCorsoSel('');
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSave = () => {
        props.saveFunction(corsoSel, props.operazione);
        handleClose();
    };

    return (
        <div>
            <Button
                variant="outlined"
                onClick={handleClickOpen}
                id={props.id}
                style={{ display: 'None' }}
            >
                Open form dialog
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="sm"
                TransitionComponent={Transition}
            >
                <DialogTitle>Associa</DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={props.corsi}
                                getOptionLabel={(option) =>
                                    option.Codice + ' - ' + option.Descrizione
                                }
                                fullWidth
                                onChange={(event, newValue) => {
                                    setCorsoSel(newValue);
                                    //handleChangeCliente(newValue);
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} fullWidth label="Corso" />
                                )}
                                sx={{ mt: 1 }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mt: 1,
                        px: 3,
                    }}
                >
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Close />}
                        onClick={handleClose}
                    >
                        Chiudi
                    </Button>
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Check />}
                        onClick={handleSave}
                    >
                        Salva
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

const DeleteDialog = (props) => {
    const [open, setOpen] = React.useState(false);
    const [openSnack, setOpenSnack] = useState(false);

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });

    const handleClickOpen = () => {
        console.log(props);
        if (props.corsoToDelete) {
            setOpen(true);
        } else {
            setSnack({
                severity: 'error',
                messaggio: 'Seleziona un corso',
            });
            setOpenSnack(true);
        }
    };
    const deleteCorso = async (idLavoratore, desRuolo) => {
        const auth = {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
            },
        };
        try {
            // Drop pregresso rows + their Allegati (no-op if the row is
            // LIVE-only). Wrapped in its own try so legacy deployments
            // without the /by-ruolo endpoint don't abort the whole flow.
            try {
                await unsplash.delete('formazionePregresso/by-ruolo', {
                    ...auth,
                    data: {
                        lavoratore: idLavoratore,
                        ruolo: desRuolo,
                    },
                });
            } catch (pregressoErr) {
                if (pregressoErr?.response?.status !== 404) {
                    console.warn(
                        'Pregresso delete failed (continuing):',
                        pregressoErr?.message
                    );
                }
            }
            // Remove the LavoratoriCorsi assignment (no-op if the row is
            // pregresso-only and LavoratoriCorsi was already cleaned up).
            await unsplash.delete('corsiLavoratore', {
                ...auth,
                data: { ruolo: desRuolo, lavoratore: idLavoratore },
            });
            setSnack({
                severity: 'success',
                messaggio: 'Corso eliminato con successo',
            });
            setOpenSnack(true);
            if (typeof props.myFunction === 'function') {
                await props.myFunction();
            }
        } catch (e) {
            const detail =
                e?.response?.data?.error || e?.message || 'errore sconosciuto';
            console.error('Errore delete corso', e);
            setSnack({
                severity: 'error',
                messaggio: `Errore durante l'eliminazione: ${detail}`,
            });
            setOpenSnack(true);
        }
        setOpen(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={handleCloseSnack}
            />
            <GridActionsCellItem
                icon={
                    <Delete
                        style={{
                            height: '2rem',
                            width: '2rem',
                            color: '#FF2768',
                        }}
                    />
                }
                label="Elimina corso"
                onClick={handleClickOpen}
            />
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                TransitionComponent={Transition}
            >
                <DialogTitle id="alert-dialog-title">
                    Sei sicuro di voler eliminare il corso associato?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Attenzione, sei sicuro di voler eliminare il corso
                        selezionato?
                    </DialogContentText>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        pr: 2,
                        pl: 2,
                    }}
                >
                    <Button onClick={handleClose}>annulla</Button>
                    <Button
                        onClick={() =>
                            deleteCorso(
                                props.corsoToDelete.ID,
                                props.corsoToDelete.Ruolo
                            )
                        }
                    >
                        Conferma
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const CorsiDialog = (props) => {
    const [loadingDoc, setLoadingDoc] = useState(false);
    const [open, setOpen] = useState(false);
    const [openSnack, setOpenSnack] = useState(false);
    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };
    const [snack, setSnack] = useState({
        severity: 'success',
        messaggio: 'Salvataggio Effettuato correttamente',
        open: false,
    });

    const [allegati, setAllegati] = useState([]);
    const [loading, setLoading] = useState(true);

    const columns = [
        {
            filterable: false,
            field: 'Actions',
            type: 'actions',
            headerName: 'Azioni',
            hide: false,
            width: 70,
            sortable: false,
            renderCell: (
                params //mi aiuta a mettere il valore
            ) => (
                <>
                    <Tooltip title="Download">
                        <IconButton
                            aria-label="edit"
                            onClick={() =>
                                downloadFile(
                                    params.row.ID,
                                    params.row.Estensione,
                                    params.row.Descrizione,
                                    'download'
                                )
                            }
                        >
                            <Download
                                style={{
                                    height: '2rem',
                                    width: '2rem',
                                    color: '#2265B1',
                                }}
                            />
                        </IconButton>
                    </Tooltip>
                </>
            ),
        },
        {
            field: 'Descrizione',
            headerName: 'Descrizione',
            flex: 1,

            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
        },
        {
            field: 'DataCorso',
            headerName: 'Data Corso',
            flex: 1,

            headerAlign: 'center',
            align: 'center',
            sort: 'asc',
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.DataCorso
                            ? moment(params.row.DataCorso).format('DD/MM/YYYY')
                            : ''}
                    </div>
                );
            },
        },
    ];

    const handleClickOpen = () => {
        setOpen(true);
        loadAllegati();
    };

    const handleClose = () => {
        setOpen(false);
    };

    const loadAllegati = async (id) => {
        let response = await unsplash.get(
            'allegati',
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                },
                params: {
                    colonna: 'DettaglioCorsoLavoratore',
                    lavoratore: props.idLavoratore,
                    tipo: props.tipo,
                },
            } //id lavoratore e la tipologia del corso
        );
        setAllegati(response.data.data);
        setLoading(false);
    };

    const downloadFile = async (id, estensione, descrizione, operazione) => {
        try {
            if (loadingDoc) {
                setSnack({
                    severity: 'error',
                    messaggio:
                        'Aspetta che la richiesta precedente sia completata prima di iniziare',
                });
                setOpenSnack(true);
            } else {
                setLoadingDoc(true);
                // Make the POST request to trigger the download and response from the server
                const response = await unsplash.post(
                    'ftp',
                    {
                        file: id + estensione,
                        nomeOriginale: descrizione.includes(estensione)
                            ? descrizione
                            : descrizione + estensione,
                        operazione: 'download',
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                        },
                        responseType: 'blob',
                    }
                );
                const url = window.URL.createObjectURL(
                    new Blob([response.data], {
                        type: ext[estensione.replace('.', '')],
                    })
                );
                const link = document.createElement('a');
                link.href = url;
                if (operazione === 'download') {
                    link.setAttribute(
                        'download',
                        descrizione.includes(estensione)
                            ? descrizione
                            : descrizione + estensione
                    );
                    document.body.appendChild(link);
                    link.click();
                }

                if (operazione === 'visualizza') {
                    if (estensione === '.pdf') {
                        window.open(url);
                    }
                }
                setLoadingDoc(false);
            }
        } catch (error) {
            let messaggio = 'Errore durante la visualizzazione del file: ';
            if (operazione === 'download') {
                messaggio = 'Errore durante il download del file: ';
            }
            setOpenSnack(true);
            if (error.response) {
                if (error.response.status === 404) {
                    messaggio = messaggio + 'File non trovato.';
                } else if (error.response.status === 500) {
                    messaggio =
                        messaggio +
                        'Errore interno del server. Si prega di riprovare più tardi.';
                } else {
                    messaggio = messaggio + 'Errore sconosciuto.';
                }
            } else if (error.request) {
                // La richiesta è stata effettuata ma non è stata ricevuta alcuna risposta
                messaggio =
                    messaggio +
                    'Nessuna risposta ricevuta dal server. Si prega di controllare la connessione a Internet.';
            } else {
                // Si è verificato qualche altro errore
                messaggio =
                    messaggio +
                    'Si è verificato un errore. Si prega di riprovare più tardi.';
            }
            setSnack({
                severity: 'error',
                messaggio: messaggio,
            });
            console.error('Errore durante il download del file:', error);
            setLoadingDoc(false);
        }
    };

    return (
        <>
            <GridActionsCellItem
                icon={
                    <Edit
                        style={{
                            height: '2rem',
                            width: '2rem',
                            color: '#2265B1',
                        }}
                    />
                }
                label="Dettaglio corso"
                onClick={handleClickOpen}
            />
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth
                maxWidth="md"
                TransitionComponent={Transition}
            >
                <GlobalSnackbar
                    severity={snack.severity}
                    messaggio={snack.messaggio}
                    openSnack={openSnack}
                    handleCloseSnack={handleCloseSnack}
                />
                <DialogTitle>{props.title}</DialogTitle>
                <DialogContent style={{ paddingTop: '20px' }}>
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs={12}
                            display="flex"
                            justifyContent="flex-end"
                            flexWrap="wrap"
                        >
                            <FileUploader
                                snack={snack}
                                openSnack={openSnack}
                                setSnack={setSnack}
                                setOpenSnack={setOpenSnack}
                                codice={props.tipo}
                                idLavoratore={props.idLavoratore}
                                reload={() => loadAllegati()}
                            />
                            <div style={{ height: 400, width: '100%' }}>
                                <DataGridPro
                                    components={{
                                        Toolbar: CustomToolbar,
                                        Footer: CustomFooterPersonalized,
                                    }}
                                    slots={{
                                        loadingOverlay: LinearProgress,
                                    }}
                                    loading={loading}
                                    initialState={{
                                        pinnedColumns: { left: ['Actions'] },
                                    }}
                                    localeText={
                                        itIT.components.MuiDataGrid.defaultProps
                                            .localeText
                                    }
                                    rows={allegati}
                                    getRowId={(allegati) => allegati.ID}
                                    columns={columns}
                                    disableSelectionOnClick
                                />
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        mt: 1,
                        px: 3,
                    }}
                >
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        startIcon={<Close />}
                        onClick={handleClose}
                    >
                        Chiudi
                    </Button>
                    {/* <Button
            variant="contained"
            className="ButtonMiller"
            startIcon={<Check />}
            onClick={handleClose}
          >
            Salva
          </Button> */}
                </DialogActions>
            </Dialog>
        </>
    );
};

export default CorsiLavoratore;

/*
SELECT

  *
FROM
  Allegati JOIN Corsi_H ON Allegati.Corso = Corsi_H.ID
WHERE
  Lavoratore = ? AND Corsi_H.Tipo  = ? AND Corsi_H.Attivo = 1



*/

const StoricoFormazioneDialog = ({
    id,
    idLavoratore,
    idAzienda,
    corsi,
    onImported,
}) => {
    // ── list state ───────────────────────────────────────────────────────────
    const [open, setOpen] = useState(false);
    const [records, setRecords] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openSnack, setOpenSnack] = useState(false);
    const [snack, setSnack] = useState({ severity: 'success', messaggio: '' });

    // ── edit state ───────────────────────────────────────────────────────────
    const [formOpen, setFormOpen] = useState(false);
    const [editRecord, setEditRecord] = useState(null);
    const emptyForm = { CodiceCorso: null, DataCompletamento: null };
    const [form, setForm] = useState(emptyForm);

    // ── PDF import state (async job pipeline) ───────────────────────────────
    const [importOpen, setImportOpen] = useState(false);
    const [importFiles, setImportFiles] = useState([]);
    const [analyzing, setAnalyzing] = useState(false);
    const [jobId, setJobId] = useState(null);
    const [jobStatus, setJobStatus] = useState(null); // 'pending'|'analyzing'|'ready'|'error'|'canceled'
    const [jobProgress, setJobProgress] = useState(null);
    const [analyzed, setAnalyzed] = useState([]);
    const [saving, setSaving] = useState(false);
    const pollRef = useRef(null);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [previewLabel, setPreviewLabel] = useState('');
    const [previewLoading, setPreviewLoading] = useState(false);

    // ── New TipiCorso creation (from within the review step) ─────────────────
    const [extraCorsi, setExtraCorsi] = useState([]);
    const [newCourseDialogFor, setNewCourseDialogFor] = useState(null); // fileId
    const [newCourseForm, setNewCourseForm] = useState({
        Codice: '',
        Descrizione: '',
        Durata: '',
        Scadenza: 0,
        DurataAggiornamento: '',
    });
    const [newCourseSaving, setNewCourseSaving] = useState(false);
    // TipiCorso catalog returned by /analyze — includes courses NOT
    // filtered by cliente, so newly created courses (still not in
    // Rel_ClientiCorsi for this cliente) are reachable from the
    // review autocomplete.
    const [analyzeCatalog, setAnalyzeCatalog] = useState([]);

    const effectiveCorsi = useMemo(() => {
        const map = new Map();
        const add = (codice, descrizione) => {
            if (!codice) return;
            if (!map.has(codice)) {
                map.set(codice, { Codice: codice, Descrizione: descrizione });
            }
        };
        (corsi || []).forEach((c) => add(c.Codice, c.Descrizione));
        extraCorsi.forEach((c) => add(c.Codice, c.Descrizione));
        analyzeCatalog.forEach((c) => add(c.code, c.description));
        return Array.from(map.values());
    }, [corsi, extraCorsi, analyzeCatalog]);

    const suggestCodiceFromName = (name) =>
        String(name || '')
            .toUpperCase()
            .replace(/[^A-Z0-9]+/g, '_')
            .replace(/^_+|_+$/g, '')
            .slice(0, 25) || 'NUOVO_CORSO';

    const openNewCourseDialog = (row) => {
        const extracted = row.extracted || {};
        setNewCourseForm({
            Codice: suggestCodiceFromName(
                extracted.nomeCorso || row.originalName
            ),
            Descrizione:
                extracted.nomeCorso || row.originalName?.replace(/\.pdf$/i, '') || '',
            Durata: extracted.durataOre ?? '',
            Scadenza: 0,
            DurataAggiornamento: '',
        });
        setNewCourseDialogFor(row.fileId);
    };

    const closeNewCourseDialog = () => {
        setNewCourseDialogFor(null);
        setNewCourseSaving(false);
    };

    const submitNewCourse = async () => {
        const payload = {
            codice: newCourseForm.Codice.trim().toUpperCase(),
            descrizione: newCourseForm.Descrizione.trim(),
            scadenza: Number(newCourseForm.Scadenza),
            durata: Number(newCourseForm.Durata || 0),
            durataAggiornamento: Number(newCourseForm.DurataAggiornamento || 0),
            clienteId: idAzienda,
        };
        if (
            !payload.codice ||
            !payload.descrizione ||
            !Number.isFinite(payload.scadenza)
        ) {
            showSnack(
                'warning',
                'Codice, descrizione e scadenza (anni) sono obbligatori'
            );
            return;
        }
        setNewCourseSaving(true);
        try {
            const res = await unsplash.post(
                'formazionePregresso/tipo-corso',
                payload,
                { headers: authHeader() }
            );
            const created = res.data?.tipoCorso;
            if (created?.Codice) {
                setExtraCorsi((prev) => [...prev, created]);
                updateAnalyzed(newCourseDialogFor, 'codiceCorso', created.Codice);
                showSnack(
                    'success',
                    `Nuovo tipo corso "${created.Codice}" creato e selezionato`
                );
                closeNewCourseDialog();
            } else {
                showSnack('error', 'Risposta inattesa dal server');
                setNewCourseSaving(false);
            }
        } catch (e) {
            const msg =
                e?.response?.data?.error ||
                'Errore durante la creazione del tipo corso';
            showSnack('error', msg);
            setNewCourseSaving(false);
        }
    };

    const authHeader = () => ({
        Authorization: `Bearer ${localStorage.getItem('jwt')}`,
    });

    // ── helpers ──────────────────────────────────────────────────────────────
    const loadRecords = async () => {
        setLoading(true);
        try {
            const res = await unsplash.get('formazionePregresso', {
                headers: authHeader(),
                params: { lavoratore: idLavoratore },
            });
            setRecords(res.data.data || []);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const showSnack = (severity, messaggio) => {
        setSnack({ severity, messaggio });
        setOpenSnack(true);
    };

    const handleOpen = () => {
        setOpen(true);
        loadRecords();
    };

    // ── edit ─────────────────────────────────────────────────────────────────
    const handleFormOpen = (record) => {
        setEditRecord(record);
        setForm({
            CodiceCorso: record.CodiceCorso || null,
            DataCompletamento: record.DataCompletamento || null,
        });
        setFormOpen(true);
    };

    const handleSave = async () => {
        if (!form.CodiceCorso || !form.DataCompletamento) {
            showSnack('error', 'Corso e data completamento sono obbligatori');
            return;
        }
        try {
            await unsplash.put(
                'formazionePregresso',
                { record: { ID: editRecord.ID, CodiceCorso: form.CodiceCorso, DataCompletamento: form.DataCompletamento } },
                { headers: authHeader() }
            );
            showSnack('success', 'Record aggiornato');
            setFormOpen(false);
            loadRecords();
        } catch {
            showSnack('error', 'Errore durante il salvataggio');
        }
    };

    const handleDelete = async (rowId) => {
        try {
            await unsplash.delete('formazionePregresso', {
                headers: authHeader(),
                data: { id: rowId },
            });
            showSnack('success', 'Record eliminato');
            loadRecords();
        } catch {
            showSnack('error', "Errore durante l'eliminazione");
        }
    };

    // ── PDF import (async job pipeline) ─────────────────────────────────────
    const stopPolling = () => {
        if (pollRef.current) {
            clearInterval(pollRef.current);
            pollRef.current = null;
        }
    };

    const startPolling = (id) => {
        stopPolling();
        pollRef.current = setInterval(async () => {
            try {
                const res = await unsplash.get(
                    `formazionePregresso/status/${id}`,
                    { headers: authHeader() }
                );
                const data = res.data || {};
                setJobStatus(data.status);
                setJobProgress(data.progress || null);
                if (data.status === 'ready') {
                    setAnalyzed(
                        (data.files || []).map((f) => ({
                            ...f,
                            destination:
                                f.cfMatchState === 'mismatch'
                                    ? 'IGNORE'
                                    : f.suggestedCodiceCorso
                                      ? 'FORMAZIONE_PREGRESSO'
                                      : 'FORMAZIONE_PREGRESSO',
                            codiceCorso: f.suggestedCodiceCorso || null,
                            tipoFormazione:
                                f.extracted?.tipoFormazione || 'BASE',
                            dataCompletamento:
                                f.extracted?.dataCompletamento || null,
                            dataInizio: f.extracted?.dataInizio || null,
                            durataOre: f.extracted?.durataOre ?? null,
                            modalita: f.extracted?.modalita || null,
                            enteErogatore: f.extracted?.enteErogatore || null,
                            numeroAttestato:
                                f.extracted?.numeroAttestato || null,
                            note: null,
                        }))
                    );
                    setAnalyzing(false);
                    stopPolling();
                } else if (data.status === 'error') {
                    showSnack('error', data.error || 'Errore di analisi');
                    setAnalyzing(false);
                    stopPolling();
                }
            } catch (e) {
                console.error('poll error', e);
            }
        }, 2000);
    };

    const handleAnalyze = async () => {
        if (!importFiles.length) return;
        setAnalyzing(true);
        setAnalyzed([]);
        setJobStatus('pending');
        setJobProgress(null);
        try {
            const formData = new FormData();
            formData.append('lavoratoreId', String(idLavoratore));
            importFiles.forEach((f) => formData.append('file', f));
            const res = await unsplash.post(
                'formazionePregresso/analyze',
                formData,
                {
                    headers: {
                        ...authHeader(),
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );
            const id = res.data?.jobId;
            if (!id) throw new Error('jobId non ricevuto');
            setJobId(id);
            setAnalyzeCatalog(res.data?.courseCatalog || []);
            startPolling(id);
        } catch (e) {
            console.error(e);
            showSnack('error', "Errore durante l'avvio dell'analisi PDF");
            setAnalyzing(false);
        }
    };

    const updateAnalyzed = (fileId, field, value) => {
        setAnalyzed((prev) =>
            prev.map((r) => (r.fileId === fileId ? { ...r, [field]: value } : r))
        );
    };

    const buildDecision = (row) => {
        if (row.destination === 'IGNORE') {
            return { fileId: row.fileId, destination: 'IGNORE' };
        }
        if (row.destination === 'FORMAZIONE_PREGRESSO') {
            return {
                fileId: row.fileId,
                destination: 'FORMAZIONE_PREGRESSO',
                codiceCorso: row.codiceCorso,
                tipoFormazione: row.tipoFormazione || 'BASE',
                dataInizio: row.dataInizio || null,
                dataCompletamento: row.dataCompletamento,
                durataOre: row.durataOre ?? null,
                modalita: row.modalita || null,
                enteErogatore: row.enteErogatore || null,
                numeroAttestato: row.numeroAttestato || null,
                note: row.note || null,
            };
        }
        return {
            fileId: row.fileId,
            destination: 'ALTRI_ATTESTATI',
            nomeCorso: row.extracted?.nomeCorso || row.originalName,
            enteErogatore: row.enteErogatore || null,
            numeroAttestato: row.numeroAttestato || null,
            dataInizio: row.dataInizio || null,
            dataCompletamento: row.dataCompletamento || null,
            durataOre: row.durataOre ?? null,
            modalita: row.modalita || null,
            note: row.note || null,
        };
    };

    const handleImportAll = async () => {
        const validRows = analyzed.filter((r) => {
            if (r.destination === 'IGNORE') return true;
            if (r.destination === 'FORMAZIONE_PREGRESSO') {
                return !!r.codiceCorso && !!r.dataCompletamento;
            }
            if (r.destination === 'ALTRI_ATTESTATI') {
                return !!(r.extracted?.nomeCorso || r.originalName);
            }
            return false;
        });
        if (validRows.length !== analyzed.length) {
            showSnack(
                'warning',
                'Alcune righe sono incomplete: corso e data completamento obbligatori per la formazione pregressa'
            );
            return;
        }
        const toImport = analyzed.filter((r) => r.destination !== 'IGNORE');
        if (!toImport.length) {
            showSnack('warning', 'Nessun attestato selezionato per l\'import');
            return;
        }
        setSaving(true);
        try {
            const decisions = analyzed.map(buildDecision);
            const res = await unsplash.post(
                'formazionePregresso/import',
                { jobId, decisions },
                { headers: authHeader() }
            );
            const importedFP = res.data?.imported?.formazionePregresso?.length || 0;
            const importedAA = res.data?.imported?.altriAttestati?.length || 0;
            const skippedList = res.data?.skipped || [];
            const skipped = skippedList.length;
            let msg = `${importedFP} record formazione pregressa, ${importedAA} altri attestati`;
            if (skipped) {
                const reasons = Array.from(
                    new Set(skippedList.map((s) => s?.reason).filter(Boolean))
                ).slice(0, 3);
                msg += ` · ${skipped} scartati: ${reasons.join(' / ')}`;
            }
            showSnack(skipped ? 'warning' : 'success', msg);
            setImportOpen(false);
            resetImportState();
            loadRecords();
            // Trigger the parent CorsiLavoratore to reload its CORSI +
            // (indirectly) ALLEGATI list so the newly imported row
            // shows up without a full page refresh.
            if (typeof onImported === 'function') {
                try {
                    await onImported();
                } catch (_e) {
                    // Best-effort: failure here doesn't roll back the
                    // import itself.
                }
            }
        } catch (e) {
            console.error(e);
            showSnack('error', "Errore durante l'importazione");
        } finally {
            setSaving(false);
        }
    };

    const resetImportState = () => {
        stopPolling();
        setImportFiles([]);
        setAnalyzed([]);
        setJobId(null);
        setJobStatus(null);
        setJobProgress(null);
        setAnalyzing(false);
        setAnalyzeCatalog([]);
    };

    const handleCancelImport = async () => {
        if (jobId && (jobStatus === 'analyzing' || jobStatus === 'ready' || jobStatus === 'pending')) {
            try {
                await unsplash.post(
                    'formazionePregresso/cleanup',
                    { jobId },
                    { headers: authHeader() }
                );
            } catch (_e) {
                // Best-effort
            }
        }
        setImportOpen(false);
        resetImportState();
    };

    // Cleanup polling on unmount.
    useEffect(() => {
        return () => stopPolling();
    }, []);

    const closePreview = () => {
        if (previewUrl) URL.revokeObjectURL(previewUrl);
        setPreviewUrl(null);
        setPreviewLabel('');
        setPreviewOpen(false);
    };

    const handlePreview = async (row) => {
        if (!jobId || !row?.fileId) return;
        setPreviewLabel(row.originalName || 'Anteprima attestato');
        setPreviewOpen(true);
        setPreviewLoading(true);
        try {
            if (previewUrl) URL.revokeObjectURL(previewUrl);
            const res = await unsplash.get(
                `formazionePregresso/preview/${jobId}/${row.fileId}`,
                { headers: authHeader(), responseType: 'blob' }
            );
            const url = URL.createObjectURL(res.data);
            setPreviewUrl(url);
        } catch (e) {
            console.error(e);
            showSnack('error', "Anteprima PDF non disponibile");
            closePreview();
        } finally {
            setPreviewLoading(false);
        }
    };

    // Revoke preview URL on unmount too.
    useEffect(() => {
        return () => {
            if (previewUrl) URL.revokeObjectURL(previewUrl);
        };
    }, [previewUrl]);

    // ── columns ──────────────────────────────────────────────────────────────
    const storicoColumns = [
        {
            field: 'Actions',
            type: 'actions',
            headerName: 'Azioni',
            width: 90,
            getActions: (params) => [
                <GridActionsCellItem
                    key="edit"
                    icon={<Edit style={{ color: '#2265B1' }} />}
                    label="Modifica"
                    onClick={() => handleFormOpen(params.row)}
                />,
                <GridActionsCellItem
                    key="delete"
                    icon={<Delete style={{ color: '#FF2768' }} />}
                    label="Elimina"
                    onClick={() => handleDelete(params.row.ID)}
                />,
            ],
        },
        { field: 'CodiceCorso', headerName: 'Codice', flex: 0.8, headerAlign: 'center', align: 'center' },
        { field: 'Descrizione', headerName: 'Corso', flex: 2, headerAlign: 'center', align: 'center' },
        {
            field: 'DataCompletamento',
            headerName: 'Data completamento',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (p) => (p.value ? moment(p.value).format('DD/MM/YYYY') : '-'),
        },
        {
            field: 'DataScadenza',
            headerName: 'Scadenza calcolata',
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (p) => {
                if (!p.row.DataCompletamento || !p.row.Scadenza) return '-';
                return moment(p.row.DataCompletamento).add(p.row.Scadenza, 'months').format('DD/MM/YYYY');
            },
        },
    ];

    // ── dropzone style ───────────────────────────────────────────────────────
    const dropzoneStyle = {
        border: '2px dashed #2265B1',
        borderRadius: 8,
        padding: '24px',
        textAlign: 'center',
        cursor: 'pointer',
        backgroundColor: '#f0f4ff',
        color: '#2265B1',
    };

    return (
        <>
            <GlobalSnackbar
                severity={snack.severity}
                messaggio={snack.messaggio}
                openSnack={openSnack}
                handleCloseSnack={() => setOpenSnack(false)}
            />
            <Button id={id} style={{ display: 'none' }} onClick={handleOpen} />
            <Button
                id={`${id}Import`}
                style={{ display: 'none' }}
                onClick={() => {
                    loadRecords();
                    setImportOpen(true);
                }}
            />

            {/* ── LIST DIALOG ── */}
            <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="lg" TransitionComponent={Transition}>
                <DialogTitle>Storico formazione pregressa</DialogTitle>
                <DialogContent style={{ paddingTop: '16px' }}>
                    <Grid container justifyContent="flex-end" sx={{ mb: 1 }}>
                        <Button
                            variant="contained"
                            className="ButtonMiller"
                            sx={{ color: 'white' }}
                            startIcon={<Upload />}
                            onClick={() => setImportOpen(true)}
                        >
                            Carica attestati PDF
                        </Button>
                    </Grid>
                    <div style={{ height: '50vh', width: '100%' }}>
                        <DataGridPro
                            components={{ Toolbar: CustomToolbar, Footer: CustomFooterPersonalized }}
                            slots={{ loadingOverlay: LinearProgress }}
                            loading={loading}
                            localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
                            rows={records}
                            getRowId={(r) => r.ID}
                            columns={storicoColumns}
                            disableSelectionOnClick
                            initialState={{ pinnedColumns: { left: ['Actions'] } }}
                        />
                    </div>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'flex-start', px: 3 }}>
                    <Button variant="contained" className="ButtonMiller" sx={{ color: 'white' }} startIcon={<Close />} onClick={() => setOpen(false)}>
                        Chiudi
                    </Button>
                </DialogActions>
            </Dialog>

            {/* ── EDIT DIALOG ── */}
            <Dialog open={formOpen} onClose={() => setFormOpen(false)} fullWidth maxWidth="sm" TransitionComponent={Transition}>
                <DialogTitle>Modifica record</DialogTitle>
                <DialogContent style={{ paddingTop: '16px' }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Autocomplete
                                options={corsi || []}
                                getOptionLabel={(o) => `${o.Codice} - ${o.Descrizione}`}
                                value={(corsi || []).find((c) => c.Codice === form.CodiceCorso) || null}
                                onChange={(_, v) => setForm({ ...form, CodiceCorso: v ? v.Codice : null })}
                                renderInput={(params) => (
                                    <TextField {...params} label="Corso *" size="small" fullWidth />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <LocalizationProvider dateAdapter={DateAdapter}>
                                <DatePicker
                                    label="Data completamento *"
                                    value={form.DataCompletamento ? moment(form.DataCompletamento) : null}
                                    onChange={(v) => setForm({ ...form, DataCompletamento: v ? v.format('YYYY-MM-DD') : null })}
                                    slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                />
                            </LocalizationProvider>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', px: 3 }}>
                    <Button variant="contained" className="ButtonMiller" sx={{ color: 'white' }} startIcon={<Close />} onClick={() => setFormOpen(false)}>
                        Annulla
                    </Button>
                    <Button variant="contained" className="ButtonMiller" sx={{ color: 'white' }} startIcon={<Check />} onClick={handleSave}>
                        Salva
                    </Button>
                </DialogActions>
            </Dialog>

            {/* ── PDF IMPORT DIALOG ── */}
            <Dialog
                open={importOpen}
                onClose={() => { if (!saving) handleCancelImport(); }}
                fullWidth
                maxWidth="md"
                TransitionComponent={Transition}
            >
                <DialogTitle>Carica attestati PDF</DialogTitle>
                <DialogContent style={{ paddingTop: '16px' }}>
                    {/* Step 1 – upload */}
                    {analyzed.length === 0 && (
                        <>
                            <Dropzone
                                accept="application/pdf"
                                onDrop={(files) => setImportFiles(files)}
                                disabled={analyzing}
                            >
                                {({ getRootProps, getInputProps }) => (
                                    <div {...getRootProps({ style: dropzoneStyle })}>
                                        <input {...getInputProps()} />
                                        <Upload sx={{ fontSize: 40, mb: 1 }} />
                                        <Typography variant="body1">
                                            Trascina qui i PDF degli attestati o clicca per selezionarli
                                        </Typography>
                                        <Typography variant="caption" color="text.secondary">
                                            Puoi caricare più file contemporaneamente
                                        </Typography>
                                    </div>
                                )}
                            </Dropzone>
                            {importFiles.length > 0 && (
                                <Box sx={{ mt: 2 }}>
                                    <Typography variant="subtitle2" gutterBottom>
                                        {importFiles.length} file selezionat{importFiles.length === 1 ? 'o' : 'i'}:
                                    </Typography>
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                        {importFiles.map((f, i) => (
                                            <Chip key={i} label={f.name} size="small" />
                                        ))}
                                    </Box>
                                </Box>
                            )}
                        </>
                    )}

                    {/* Step 2 – review */}
                    {analyzed.length > 0 && (
                        <Box>
                            <Alert severity="info" sx={{ mb: 2 }}>
                                Verifica i dati estratti da ciascun attestato, scegli la destinazione e conferma l'import.
                            </Alert>
                            {analyzed.map((row) => {
                                const destColor =
                                    row.destination === 'IGNORE'
                                        ? 'grey.400'
                                        : row.destination === 'FORMAZIONE_PREGRESSO'
                                          ? 'primary.main'
                                          : 'warning.main';
                                const cfLabel =
                                    row.cfMatchState === 'match'
                                        ? 'CF OK'
                                        : row.cfMatchState === 'mismatch'
                                          ? 'CF diverso!'
                                          : row.cfMatchState === 'name-match'
                                            ? 'Nome/Cognome OK'
                                            : 'CF non rilevato';
                                const cfColor =
                                    row.cfMatchState === 'match'
                                        ? 'success'
                                        : row.cfMatchState === 'mismatch'
                                          ? 'error'
                                          : row.cfMatchState === 'name-match'
                                            ? 'success'
                                            : 'warning';
                                const confPct = Math.round(
                                    (row.matchConfidence || 0) * 100
                                );
                                const matchBadge =
                                    confPct >= 70
                                        ? { label: `Match ${confPct}%`, color: 'success' }
                                        : confPct >= 40
                                          ? { label: `Match debole ${confPct}%`, color: 'warning' }
                                          : { label: 'Match mancante', color: 'default' };
                                return (
                                    <Box
                                        key={row.fileId}
                                        sx={{
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            borderLeft: '4px solid',
                                            borderLeftColor: destColor,
                                            borderRadius: 1,
                                            p: 2,
                                            mb: 2,
                                            opacity: row.destination === 'IGNORE' ? 0.55 : 1,
                                            backgroundColor: row.destination === 'IGNORE' ? 'grey.50' : 'background.paper',
                                        }}
                                    >
                                        <Grid container alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                            <Grid item xs>
                                                <Chip label={row.originalName} size="small" variant="outlined" />
                                                <IconButton
                                                    size="small"
                                                    title="Visualizza PDF"
                                                    onClick={() => handlePreview(row)}
                                                    sx={{ ml: 0.5 }}
                                                >
                                                    <Visibility fontSize="small" />
                                                </IconButton>
                                                <Chip
                                                    label={cfLabel}
                                                    color={cfColor}
                                                    size="small"
                                                    sx={{ ml: 1 }}
                                                />
                                                {row.destination === 'FORMAZIONE_PREGRESSO' && (
                                                    <Chip
                                                        label={matchBadge.label}
                                                        color={matchBadge.color}
                                                        size="small"
                                                        variant={confPct >= 70 ? 'filled' : 'outlined'}
                                                        sx={{ ml: 1 }}
                                                    />
                                                )}
                                                {row.extracted?.ente && row.extracted.ente !== 'GENERIC' && (
                                                    <Chip
                                                        label={row.extracted.ente}
                                                        size="small"
                                                        variant="outlined"
                                                        sx={{ ml: 1 }}
                                                    />
                                                )}
                                                {row.extracted?.nomeCorso && confPct < 100 && (
                                                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                                                        Corso estratto: {row.extracted.nomeCorso}
                                                    </Typography>
                                                )}
                                                {row.anomalies?.length > 0 && (
                                                    <Typography variant="caption" color="warning.dark" sx={{ display: 'block' }}>
                                                        ⚠ {row.anomalies.join(' · ')}
                                                    </Typography>
                                                )}
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    select
                                                    size="small"
                                                    label="Destinazione"
                                                    value={row.destination}
                                                    onChange={(e) => updateAnalyzed(row.fileId, 'destination', e.target.value)}
                                                    sx={{ minWidth: 220 }}
                                                >
                                                    <MenuItem value="FORMAZIONE_PREGRESSO">Formazione pregressa</MenuItem>
                                                    <MenuItem value="ALTRI_ATTESTATI">Altri attestati</MenuItem>
                                                    <MenuItem value="IGNORE">Ignora</MenuItem>
                                                </TextField>
                                            </Grid>
                                        </Grid>
                                        {row.destination === 'FORMAZIONE_PREGRESSO' && (
                                            <Grid container spacing={1}>
                                                <Grid item xs={12} sm={6}>
                                                    <Autocomplete
                                                        options={effectiveCorsi}
                                                        getOptionLabel={(o) => `${o.Codice} - ${o.Descrizione}`}
                                                        value={effectiveCorsi.find((c) => c.Codice === row.codiceCorso) || null}
                                                        onChange={(_, v) => updateAnalyzed(row.fileId, 'codiceCorso', v ? v.Codice : null)}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label={`Corso *${row.matchConfidence > 0 ? ` (match ${Math.round(row.matchConfidence * 100)}%)` : ''}`}
                                                                size="small"
                                                                fullWidth
                                                                error={!row.codiceCorso}
                                                            />
                                                        )}
                                                    />
                                                    {row.topCourseMatches?.length > 0 && (
                                                        <Box sx={{ mt: 0.5, display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
                                                            <Typography variant="caption" color="text.secondary" sx={{ mr: 0.5 }}>
                                                                Suggeriti:
                                                            </Typography>
                                                            {row.topCourseMatches
                                                                .filter((s) => s.score > 0)
                                                                .slice(0, 3)
                                                                .map((s) => {
                                                                    const desc = s.description
                                                                        ? s.description.length > 55
                                                                            ? s.description.slice(0, 55) + '…'
                                                                            : s.description
                                                                        : '';
                                                                    const label = desc
                                                                        ? `${s.code} · ${desc}`
                                                                        : s.code;
                                                                    return (
                                                                        <Chip
                                                                            key={s.code}
                                                                            label={label}
                                                                            title={s.description || s.code}
                                                                            size="small"
                                                                            variant={row.codiceCorso === s.code ? 'filled' : 'outlined'}
                                                                            color={row.codiceCorso === s.code ? 'primary' : 'default'}
                                                                            onClick={() => updateAnalyzed(row.fileId, 'codiceCorso', s.code)}
                                                                            clickable
                                                                        />
                                                                    );
                                                                })}
                                                        </Box>
                                                    )}
                                                    <Button
                                                        size="small"
                                                        variant="text"
                                                        onClick={() => openNewCourseDialog(row)}
                                                        sx={{ mt: 0.5, textTransform: 'none' }}
                                                    >
                                                        + Crea nuovo tipo corso da questo attestato
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <TextField
                                                        select
                                                        size="small"
                                                        label="Tipo"
                                                        value={row.tipoFormazione}
                                                        onChange={(e) => updateAnalyzed(row.fileId, 'tipoFormazione', e.target.value)}
                                                        fullWidth
                                                    >
                                                        <MenuItem value="BASE">Base</MenuItem>
                                                        <MenuItem value="AGGIORNAMENTO">Aggiornamento</MenuItem>
                                                    </TextField>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <LocalizationProvider dateAdapter={DateAdapter}>
                                                        <DatePicker
                                                            label="Completamento *"
                                                            value={row.dataCompletamento ? moment(row.dataCompletamento) : null}
                                                            onChange={(v) => updateAnalyzed(row.fileId, 'dataCompletamento', v ? v.format('YYYY-MM-DD') : null)}
                                                            slotProps={{ textField: { size: 'small', fullWidth: true, error: !row.dataCompletamento } }}
                                                        />
                                                    </LocalizationProvider>
                                                </Grid>
                                                <Grid item xs={6} sm={3}>
                                                    <LocalizationProvider dateAdapter={DateAdapter}>
                                                        <DatePicker
                                                            label="Inizio"
                                                            value={row.dataInizio ? moment(row.dataInizio) : null}
                                                            onChange={(v) => updateAnalyzed(row.fileId, 'dataInizio', v ? v.format('YYYY-MM-DD') : null)}
                                                            slotProps={{ textField: { size: 'small', fullWidth: true } }}
                                                        />
                                                    </LocalizationProvider>
                                                </Grid>
                                                <Grid item xs={6} sm={2}>
                                                    <TextField
                                                        size="small"
                                                        label="Durata (h)"
                                                        type="number"
                                                        value={row.durataOre ?? ''}
                                                        onChange={(e) => updateAnalyzed(row.fileId, 'durataOre', e.target.value ? Number(e.target.value) : null)}
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={12} sm={7}>
                                                    <TextField
                                                        size="small"
                                                        label="Ente erogatore"
                                                        value={row.enteErogatore || ''}
                                                        onChange={(e) => updateAnalyzed(row.fileId, 'enteErogatore', e.target.value)}
                                                        fullWidth
                                                    />
                                                </Grid>
                                            </Grid>
                                        )}
                                    </Box>
                                );
                            })}
                        </Box>
                    )}

                    {analyzing && analyzed.length === 0 && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
                            <CircularProgress size={24} />
                            <Typography>
                                Analisi PDF in corso
                                {jobProgress
                                    ? ` (${jobProgress.processedPages || 0}/${jobProgress.totalPages || '?'} pagine)`
                                    : '…'}
                            </Typography>
                        </Box>
                    )}
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', px: 3 }}>
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        sx={{ color: 'white' }}
                        startIcon={<Close />}
                        onClick={handleCancelImport}
                        disabled={saving}
                    >
                        Annulla
                    </Button>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        {analyzed.length > 0 && (
                            <Button
                                variant="contained"
                                className="ButtonMiller"
                                sx={{ color: 'white' }}
                                onClick={() => { stopPolling(); setAnalyzed([]); setImportFiles([]); setJobId(null); setJobStatus(null); }}
                                disabled={saving}
                            >
                                Ricarica file
                            </Button>
                        )}
                        {analyzed.length === 0 && (
                            <Button
                                variant="contained"
                                className="ButtonMiller"
                                sx={{ color: 'white' }}
                                onClick={handleAnalyze}
                                disabled={!importFiles.length || analyzing}
                                startIcon={analyzing ? <CircularProgress size={16} color="inherit" /> : null}
                            >
                                Analizza
                            </Button>
                        )}
                        {analyzed.length > 0 && (
                            <Button
                                variant="contained"
                                className="ButtonMiller"
                                sx={{ color: 'white' }}
                                startIcon={<Check />}
                                onClick={handleImportAll}
                                disabled={saving}
                            >
                                {saving
                                    ? 'Importazione…'
                                    : `Importa (${analyzed.filter((r) => r.destination !== 'IGNORE').length})`}
                            </Button>
                        )}
                    </Box>
                </DialogActions>
            </Dialog>

            {/* ── NEW TIPO CORSO DIALOG ── */}
            <Dialog
                open={newCourseDialogFor !== null}
                onClose={newCourseSaving ? undefined : closeNewCourseDialog}
                fullWidth
                maxWidth="sm"
                TransitionComponent={Transition}
            >
                <DialogTitle>Crea nuovo tipo corso</DialogTitle>
                <DialogContent sx={{ paddingTop: '16px !important' }}>
                    <Alert severity="info" sx={{ mb: 2 }}>
                        Il nuovo tipo corso sarà disponibile per tutti i
                        lavoratori. Impostando scadenza 0 (default) il corso
                        non richiede aggiornamento periodico.
                    </Alert>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                label="Codice *"
                                size="small"
                                fullWidth
                                value={newCourseForm.Codice}
                                onChange={(e) =>
                                    setNewCourseForm({
                                        ...newCourseForm,
                                        Codice: e.target.value
                                            .toUpperCase()
                                            .slice(0, 25),
                                    })
                                }
                                helperText="Max 25 caratteri, A-Z 0-9 _"
                            />
                        </Grid>
                        <Grid item xs={12} sm={8}>
                            <TextField
                                label="Descrizione *"
                                size="small"
                                fullWidth
                                value={newCourseForm.Descrizione}
                                onChange={(e) =>
                                    setNewCourseForm({
                                        ...newCourseForm,
                                        Descrizione: e.target.value,
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            <TextField
                                label="Durata (ore)"
                                size="small"
                                type="number"
                                fullWidth
                                value={newCourseForm.Durata}
                                onChange={(e) =>
                                    setNewCourseForm({
                                        ...newCourseForm,
                                        Durata: e.target.value,
                                    })
                                }
                            />
                        </Grid>
                        <Grid item xs={6} sm={4}>
                            <TextField
                                label="Scadenza (anni, 0 = nessuna)"
                                size="small"
                                type="number"
                                fullWidth
                                value={newCourseForm.Scadenza}
                                onChange={(e) =>
                                    setNewCourseForm({
                                        ...newCourseForm,
                                        Scadenza: e.target.value,
                                    })
                                }
                                inputProps={{ min: 0, max: 20 }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField
                                label="Durata aggiornamento (ore)"
                                size="small"
                                type="number"
                                fullWidth
                                value={newCourseForm.DurataAggiornamento}
                                onChange={(e) =>
                                    setNewCourseForm({
                                        ...newCourseForm,
                                        DurataAggiornamento: e.target.value,
                                    })
                                }
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', px: 3 }}>
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        sx={{ color: 'white' }}
                        startIcon={<Close />}
                        onClick={closeNewCourseDialog}
                        disabled={newCourseSaving}
                    >
                        Annulla
                    </Button>
                    <Button
                        variant="contained"
                        className="ButtonMiller"
                        sx={{ color: 'white' }}
                        startIcon={newCourseSaving ? <CircularProgress size={14} color="inherit" /> : <Check />}
                        onClick={submitNewCourse}
                        disabled={newCourseSaving}
                    >
                        {newCourseSaving ? 'Creazione…' : 'Crea e seleziona'}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* ── PDF PREVIEW DIALOG ── */}
            <Dialog
                open={previewOpen}
                onClose={closePreview}
                fullWidth
                maxWidth="lg"
                TransitionComponent={Transition}
            >
                <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span>{previewLabel}</span>
                    <IconButton onClick={closePreview} size="small">
                        <Close fontSize="small" />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ p: 0, height: '80vh' }}>
                    {previewLoading && (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', gap: 2 }}>
                            <CircularProgress size={24} />
                            <Typography>Caricamento anteprima…</Typography>
                        </Box>
                    )}
                    {!previewLoading && previewUrl && (
                        <iframe
                            title="Anteprima PDF attestato"
                            src={previewUrl}
                            style={{ width: '100%', height: '100%', border: 0 }}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};

const FileUploader = (props) => {
    const [open, setOpen] = useState(false);
    const { isDragAccept, isDragReject, isFocused } = useDropzone();

    const [files, setFiles] = useState([]);
    const [dataCorso, setDataCorso] = useState(null);
    const [aggiornamento, setAggiornamento] = useState(0);

    const baseStyle = useMemo(
        () => ({
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20px',
            borderWidth: 2,
            borderRadius: 2,
            borderColor: '#eeeeee',
            borderStyle: 'dashed',
            backgroundColor: '#fafafa',
            color: '#bdbdbd',
            outline: 'none',
            transition: 'border .24s ease-in-out',
        }),
        []
    );

    const focusedStyle = useMemo(
        () => ({
            borderColor: '#2196f3',
        }),
        []
    );

    const acceptStyle = useMemo(
        () => ({
            borderColor: '#00e676',
        }),
        []
    );

    const rejectStyle = useMemo(
        () => ({
            borderColor: '#ff1744',
        }),
        []
    );

    const handleUpload = async () => {
        if (!dataCorso) {
            props.setSnack({
                severity: 'error',
                messaggio: 'Attenzione seleziona la data del corso',
            });
            props.setOpenSnack(true);
        } else {
            if (files.length === 0) {
                props.setSnack({
                    severity: 'error',
                    messaggio: 'Nessun file caricato',
                });
                props.setOpenSnack(true);
            } else {
                let corso = {
                    Tipo: props.codice,
                    Aggiornamento: aggiornamento,
                };

                try {
                    let responseCorso = await unsplash.post(
                        'corsi',
                        { corso: corso, tipo: 'H' }, //Creo corso header STEP 1
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                            },
                        }
                    );
                    let idCorso = responseCorso.data.message.insertId;
                    let corsoRiga = {
                        Corso: idCorso,
                        Data: moment(dataCorso).format('YYYY-MM-DD'),
                        Presenza: 1,
                        Fatturato: 1,
                        Lavoratore: props.idLavoratore,
                        CorsoNonInterno: 1,
                    };
                    await unsplash.post(
                        'corsi',
                        { corso: corsoRiga, tipo: 'R' }, //Creo corso header STEP 1
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                            },
                        }
                    );

                    const formData = new FormData();
                    formData.append('colonna', 'Corso');
                    formData.append('ID', idCorso);
                    formData.append('colonnaExtra', 'Lavoratore');
                    formData.append('extra', props.idLavoratore); //extra è da modificare con l'id del lavoratroe
                    files.forEach((file) => {
                        formData.append('file', file);
                    });
                    await unsplash
                        .post('caricaDoc', formData, {
                            headers: {
                                'content-type': 'multipart/form-data',
                                Authorization: `Bearer ${localStorage.getItem('jwt')}`,
                            },
                        })
                        .then((res) => {
                            props.setSnack({
                                severity: 'success',
                                messaggio: 'File caricato con successo',
                            });
                            props.setOpenSnack(true);
                            setOpen(false);
                            props.reload();
                        });
                } catch {
                    props.setSnack({
                        severity: 'error',
                        messaggio: 'Errore nel caricamento del file',
                    });
                    props.setOpenSnack(true);
                    setOpen(false);
                }
            }
        }
    };

    const handleClose = () => {
        setOpen(false);
    };
    const onDrop = (acceptedFiles) => {
        setFiles(acceptedFiles);
    };

    const style = useMemo(
        () => ({
            ...baseStyle,
            ...(isFocused ? focusedStyle : {}),
            ...(isDragAccept ? acceptStyle : {}),
            ...(isDragReject ? rejectStyle : {}),
        }),
        [
            isFocused,
            isDragAccept,
            isDragReject,
            acceptStyle,
            baseStyle,
            focusedStyle,
            rejectStyle,
        ]
    );

    return (
        <>
            <Button
                startIcon={<Upload />}
                variant="contained"
                className="ButtonMiller"
                style={{ marginBottom: '10px' }}
                onClick={() => {
                    setOpen(true);
                    setFiles([]);
                    setAggiornamento(0);
                }}
            >
                Carica
            </Button>
            <Dialog
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <DialogTitle>Carica File</DialogTitle>
                <DialogContent>
                    <FormControlLabel
                        control={
                            <Checkbox
                                sx={{ marginLeft: '10px' }}
                                name="Aggiornamento"
                                checked={aggiornamento === 1 ? true : false}
                                onChange={(e) => {
                                    setAggiornamento(e.target.checked ? 1 : 0);
                                }}
                            />
                        }
                        label="Aggiornamento"
                    />
                    <LocalizationProvider dateAdapter={DateAdapter}>
                        <DatePicker
                            ampmInClock={false}
                            slotProps={{
                                textField: {
                                    sx: { marginBottom: '10px' },
                                    size: 'small',
                                    fullWidth: true,
                                },
                            }}
                            label="Data corso"
                            value={dataCorso ? moment(dataCorso) : null}
                            onChange={(newValue) => {
                                setDataCorso(
                                    newValue
                                        ? newValue.format('YYYY-MM-DD')
                                        : null
                                );
                            }}
                        />
                    </LocalizationProvider>

                    <Dropzone onDrop={(acceptedFiles) => onDrop(acceptedFiles)}>
                        {({ getRootProps, getInputProps }) => (
                            <div {...getRootProps({ style })}>
                                <input {...getInputProps()} />
                                <p>
                                    Trascina e rilascia qui o fai clic per
                                    selezionare i file
                                </p>
                            </div>
                        )}
                    </Dropzone>
                    <aside>
                        <h4>Files</h4>
                        {files?.map((file) => {
                            return (
                                <>
                                    <ul>{file.path}</ul>
                                </>
                            );
                        })}
                    </aside>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        mt: 1,
                        px: 3,
                    }}
                >
                    <Button onClick={handleClose}>Annulla</Button>
                    <Button onClick={handleUpload}>Carica</Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
